export const inputData = {
    defaultValue: 0,
    max: 1,
    min: 0,
    step: 0.001,
};
